// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { node, number } from 'prop-types'
import { CaptionItemWrapper } from './styles'

const CaptionItem = ({ children, count }) => (
  <CaptionItemWrapper>
    <strong>{count.toLocaleString()}</strong>
    <span>{children}</span>
  </CaptionItemWrapper>
)

CaptionItem.propTypes = {
  children: node.isRequired,
  count: number.isRequired,
}

export default CaptionItem
